const device_connector_mapping = [
  {
    connector_type: "A",
    connector_id: 1,
    devices: [
      {
        device_id: 6,
        board_pins: {
          supply: "5V",
          ground: "GND",
          signals: ["GPIO18", "GPIO21", "GPIO22", "GPIO5"],
        },
        code_snippet: "digitalWrite(13, HIGH);",
      },
    ],
  },
  {
    connector_type: "B",
    connector_id: 2,
    devices: [
      {
        device_id: 2,
        board_pins: { supply: "5V", ground: "GND", signals: ["GPIO2"] },
        code_snippet: "digitalWrite(13, HIGH);",
      },
    ],
  },
  {
    connector_type: "C",
    connector_id: 3,
    devices: [
      {
        device_id: 8,
        board_pins: {
          supply: "5V",
          ground: "GND",
          signals: ["GPIO27", "GPIO14", "GPIO12"],
        },
        code_snippet: "digitalWrite(13, HIGH);",
      },
    ],
  },
  {
    connector_type: "D",
    connector_id: 4,
    devices: [
      {
        device_id: 1,
        board_pins: { supply: "5V", ground: "GND", signals: ["GPIO13"] },
        code_snippet: "digitalWrite(13, HIGH);",
      },
      {
        device_id: 3,
        board_pins: { supply: "3.3V", ground: "GND", signals: ["GPIO13"] },
        code_snippet: "digitalWrite(13, HIGH);",
      },
      {
        device_id: 4,
        board_pins: { supply: "3.3V", ground: "GND", signals: ["GPIO13"] },
        code_snippet: "digitalWrite(13, HIGH);",
      },
      {
        device_id: 7,
        board_pins: {
          supply: "3.3V",
          ground: "GND",
          signals: ["GPIO15", "GPIO13"],
        },
        code_snippet: "digitalWrite(13, HIGH);",
      },
    ],
  },
  {
    connector_type: "E",
    connector_id: 5,
    devices: [
      {
        device_id: 1,
        board_pins: { supply: "5V", ground: "GND", signals: ["GPIO32"] },
        code_snippet: "digitalWrite(32, HIGH);",
      },
      {
        device_id: 3,
        board_pins: { supply: "3.3V", ground: "GND", signals: ["GPIO32"] },
        code_snippet: "digitalWrite(32, HIGH);",
      },
      {
        device_id: 4,
        board_pins: { supply: "3.3V", ground: "GND", signals: ["GPIO32"] },
        code_snippet: "digitalWrite(32, HIGH);",
      },
      {
        device_id: 7,
        board_pins: {
          supply: "3.3V",
          ground: "GND",
          signals: ["GPIO33", "GPIO32"],
        },
        code_snippet: "digitalWrite(33), HIGH);",
      },
    ],
  },
  {
    connector_type: "F",
    connector_id: 6,
    devices: [
      {
        device_id: 9,
        board_pins: { supply: null, ground: "GND", signals: ["GPIO4"] },
        code_snippet: "digitalWrite(04, HIGH);",
      },
      {
        device_id: 10,
        board_pins: {
          supply: null,
          ground: "GND",
          signals: ["GPIO4", "GPIO0"],
        },
        code_snippet: "digitalWrite(04, HIGH);",
      },
    ],
  },
  {
    connector_type: "G",
    connector_id: 7,
    devices: [
      {
        device_id: 9,
        board_pins: { supply: null, ground: "GND", signals: ["GPIO34"] },
        code_snippet: "digitalWrite(04, HIGH);",
      },
      {
        device_id: 10,
        board_pins: {
          supply: null,
          ground: "GND",
          signals: ["GPI34", "GPIO35"],
        },
        code_snippet: "digitalWrite(04, HIGH);",
      },
    ],
  },
];

export default device_connector_mapping;
